import type { RiskBadgeWrapperProps } from "./risk-badge.type";

import { RiskBadge } from "./risk-badge.component";

export const RiskBadgeWrapper = ({ risk }: RiskBadgeWrapperProps) => {
  if (!risk) return null;

  return <RiskBadge risk={risk} />;
};
